import * as activityStreamActions from '@xmatters/redux/actions/activityStream';

const defaultState = {
  filter: [],
};

export default function activityStream(state = defaultState, action) {
  const { type, payload } = action;
  switch (type) {
    case activityStreamActions.FILTER_ACTIVITY_STREAM: {
      return {
        ...state,
        filter: payload.filter,
      };
    }
    default:
      return state;
  }
}
